import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";

const lesson: Lesson = {
  id: "2a91c443-fccb-44a9-9adb-04f0a23acd01",
  publicId: "32",
  name: "Measurement of a loudspeaker driver",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  showHeaderNavigation: true,

  body: [principle01, principle02, principle03],
};

export default lesson;
